import { useState, useEffect } from "react";
import { useAuthStore } from "../store/auth.store";
import { NavLink } from "react-router";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Role } from "../utils/Role";
import { useTranslation } from "../hooks/useTranslation";

export function Layout({ children }) {
  const { t } = useTranslation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const user = useAuthStore((state) => state.user);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [showMenu, setShowMenu] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);

  const handleClickOutside = (event) => {
    const target = event.target;

    // Procházíme stromem rodičů a hledáme třídu "menu-sub-dropdown"
    let parent = target;
    while (parent) {
      if (parent.classList?.contains("app-navbar-item")) {
        return; // Nezavíráme dropdown, pokud se klikne na prvek s touto třídou
      }
      parent = parent.parentElement;
    }

    setShowUserMenu(null);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Při změně velikosti okna aktualizuj hodnoty
    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleClickOutside);

    // Čistící funkce pro odstranění event listeneru
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const pagename = useBreadcrumbsStore((state) => state.pagename);
  const breadcrumbs = useBreadcrumbsStore((state) => state.breadcrumbs);

  const logout = () => {
    clearAuth();
  };

  return (
    <>
      <div className="page d-flex flex-column flex-column-fluid">
        <div
          id="kt_app_header"
          className="app-header"
          data-kt-sticky="true"
          data-kt-sticky-activate="{default: false, lg: true}"
          data-kt-sticky-name="app-header-sticky"
          data-kt-sticky-offset="{default: false, lg: '300px'}"
          style={{ animationDuration: "0.3s" }}
        >
          <div
            className="app-container container-xxl d-flex align-items-stretch justify-content-between"
            id="kt_app_header_container"
          >
            <div
              className="d-flex align-items-center d-lg-none ms-n3 me-2"
              title="Show sidebar menu"
              onClick={() => setShowMenu(true)}
            >
              <div
                className="btn btn-icon btn-color-white btn-active-color-primary w-35px h-35px"
                id="kt_app_header_menu_toggle"
              >
                <i className="ki-duotone ki-abstract-14 fs-2">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </div>
            </div>

            <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15">
              <a href="/">
                <img
                  alt="Logo"
                  src="/assets/media/logo-exn.png"
                  className="h-55px d-none d-lg-inline"
                />
                <img
                  alt="Logo"
                  src="/assets/media/logo-exn.png"
                  className="h-25px d-inline d-lg-none"
                />
              </a>
            </div>

            <div
              className="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
              id="kt_app_header_wrapper"
            >
              <div
                className={
                  "app-header-menu app-header-mobile-drawer align-items-stretch " +
                  (windowSize?.width < 992
                    ? "drawer drawer-start w-250px " +
                      (showMenu ? "drawer-on" : "")
                    : "")
                }
                data-kt-drawer="true"
                data-kt-drawer-name="app-header-menu"
                data-kt-drawer-activate="{default: true, lg: false}"
                data-kt-drawer-overlay="true"
                data-kt-drawer-width="250px"
                data-kt-drawer-direction="start"
                data-kt-drawer-toggle="#kt_app_header_menu_toggle"
                data-kt-swapper="true"
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <div
                  className="menu menu-rounded menu-active-bg menu-state-primary menu-column menu-lg-row menu-title-gray-700 menu-icon-gray-500 menu-arrow-gray-500 menu-bullet-gray-500 my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0"
                  id="kt_app_header_menu"
                  data-kt-menu="true"
                >
                  <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() => setShowMenu(false)}
                      to="/"
                      className={({ isActive }) =>
                        isActive ? "menu-link active" : "menu-link"
                      }
                    >
                      <span className="menu-title">{t("navigation.dashboard")}</span>
                    </NavLink>
                  </div>

                  <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() =>
                        setShowSubMenu(
                          showSubMenu === "prilezitosti"
                            ? false
                            : "prilezitosti"
                        )
                      }
                      to="/prilezitosti"
                      className={({ isActive }) =>
                        (isActive ? "menu-link active" : "menu-link") +
                        " " +
                        (showSubMenu == "prilezitosti" ? "open" : "notopen")
                      }
                    >
                      <span className="menu-title">Obchod</span>
                      <span className="menu-arrow d-lg-none"></span>
                    </NavLink>

                    <div
                      className={
                        "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown" +
                        (windowSize?.width < 992
                          ? " ps-2 mt-7 w-100"
                          : " w-250px")
                      }
                      style={{ backgroundColor: "white" }}
                    >
                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/klienti"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">Klienti</span>
                        </NavLink>
                      </div>
                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/prilezitosti"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("navigation.opportunities")}</span>
                        </NavLink>
                      </div>

                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/faktury"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("navigation.invoices")}</span>
                        </NavLink>
                      </div>

                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/obnovy-licenci"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("navigation.renewals")}</span>
                        </NavLink>
                      </div>

                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/samoobsluha"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">Samoobsluha</span>
                        </NavLink>
                      </div>

                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/vyprodej"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("navigation.clearance")}</span>
                        </NavLink>
                      </div>

                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/statistika-obchodu"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">Statistika obchodu</span>
                        </NavLink>
                      </div>
                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/prodana-sn"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("navigation.soldSn")}</span>
                        </NavLink>
                      </div>
                      {/*
                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/reklamace"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("claims.title")}</span>
                        </NavLink>
                      </div>
                      */}
                    </div>
                  </div>

                  {Role.isLogmanagerPartner(user) && (
                    <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                      <NavLink
                        onClick={() => setShowMenu(false)}
                        to="/dealy"
                        className={({ isActive }) =>
                          isActive ? "menu-link active" : "menu-link"
                        }
                      >
                        <span className="menu-title">{t("navigation.registration")}</span>
                      </NavLink>
                    </div>
                  )}

                  <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() => setShowMenu(false)}
                      to="/produkty"
                      className={({ isActive }) =>
                        isActive ? "menu-link active" : "menu-link"
                      }
                    >
                      <span className="menu-title">Produkty</span>
                    </NavLink>
                  </div>

                  <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() =>
                        setShowSubMenu(
                          showSubMenu === "zapujcky" ? false : "zapujcky"
                        )
                      }
                      to="/zapujcky"
                      className={({ isActive }) =>
                        (isActive ? "menu-link active" : "menu-link") +
                        " " +
                        (showSubMenu == "zapujcky" ? "open" : "notopen")
                      }
                    >
                      <span className="menu-title">Support</span>
                      <span className="menu-arrow d-lg-none"></span>
                    </NavLink>

                    <div
                      className={
                        "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown" +
                        (windowSize?.width < 992
                          ? " ps-2 mt-7 w-100"
                          : " w-250px")
                      }
                      style={{ backgroundColor: "white" }}
                    >
                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/zapujcky"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">{t("navigation.loans")}</span>
                        </NavLink>
                      </div>
                      <div className="menu-item">
                        <NavLink
                          onClick={() => setShowMenu(false)}
                          to="/fortinet/neregistrovane-licence"
                          className={({ isActive }) =>
                            isActive ? "menu-link active" : "menu-link"
                          }
                        >
                          <span className="menu-title">
                            {t("navigation.fortinetLicenses")}
                          </span>
                        </NavLink>
                      </div>
                    </div>
                  </div>

                  <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() => setShowMenu(false)}
                      to="/marketing"
                      className={({ isActive }) =>
                        isActive ? "menu-link active" : "menu-link"
                      }
                    >
                      <span className="menu-title">{t("navigation.marketing")}</span>
                    </NavLink>
                  </div>

                  <div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() => setShowMenu(false)}
                      to="/akce"
                      className={({ isActive }) =>
                        isActive ? "menu-link active" : "menu-link"
                      }
                    >
                      <span className="menu-title">{t("navigation.calendar")}</span>
                    </NavLink>
                  </div>

                  {/*<div className="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                    <NavLink
                      onClick={() => setShowMenu(false)}
                      to="/kontakty"
                      className={({ isActive }) =>
                        isActive ? "menu-link active" : "menu-link"
                      }
                    >
                      <span className="menu-title">Kontakty</span>
                    </NavLink>
                  </div>*/}
                </div>
              </div>

              <div className="app-navbar flex-shrink-0">
                <div className="d-flex align-items-center ms-2 ms-lg-3">
                  <div
                    id="kt_header_search"
                    className="header-search d-flex align-items-center topbar-search w-lg-225px"
                    data-kt-search-keypress="true"
                    data-kt-search-min-length="2"
                    data-kt-search-enter="enter"
                    data-kt-search-layout="menu"
                    data-kt-search-responsive="lg"
                    data-kt-menu-trigger="auto"
                    data-kt-menu-permanent="true"
                    data-kt-menu-placement="bottom-end"
                    data-kt-search="true"
                  >
                    <div
                      data-kt-search-element="toggle"
                      className="search-toggle-mobile d-flex d-lg-none align-items-center"
                    >
                      <div className="d-flex btn btn-icon btn-icon-gray-300 w-30px h-30px w-md-40px h-md-40px">
                        <i className="ki-duotone ki-magnifier fs-1">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="app-navbar-item ms-1 ms-lg-3 position-relative"
                  id="kt_header_user_menu_toggle"
                >
                  <div
                    className="cursor-pointer symbol symbol-35px"
                    onClick={() => setShowUserMenu(!showUserMenu)}
                    data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                  >
                    <img
                      className="symbol symbol-35px"
                      src="/assets/media/avatars/blank.png"
                      alt="user"
                    />
                  </div>

                  <div
                    className={
                      "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px " +
                      (showUserMenu ? "show" : "")
                    }
                    style={
                      showUserMenu
                        ? {
                            zIndex: 107,
                            position: "absolute",
                            inset: "0px 0px auto auto",
                            margin: "0px",
                            transform: "translate(0px, 90px)",
                          }
                        : {}
                    }
                    data-popper-placement="bottom-end"
                    data-kt-menu="true"
                  >
                    <div className="menu-item px-3">
                      <div className="menu-content d-flex align-items-center px-3">
                        <div className="symbol symbol-50px me-5">
                          <img
                            alt="Logo"
                            src="/assets/media/avatars/blank.png"
                          />
                        </div>

                        <div className="d-flex flex-column">
                          <div className="fw-bold d-flex align-items-center fs-5">
                            {user && user.name}
                            {/*<span
                                                            className="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2">Pro</span>
                                                            */}
                          </div>
                          <a
                            href="#"
                            className="fw-semibold text-muted text-hover-primary fs-7"
                          >
                            {user && user.email}
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="separator my-2"></div>

                    {/*
                                        
                                        <div className="menu-item px-5">
                                            <a href="account/overview.html" className="menu-link px-5">Profil</a>
                                        </div>
                                        
                                        
                                        <div className="menu-item px-5">
                                            <a href="apps/projects/list.html" className="menu-link px-5">
                                                <span className="menu-text">Obchodní případy</span>
                                                <span className="menu-badge">
													<span
                                                        className="badge badge-light-danger badge-circle fw-bold fs-7">3</span>
												</span>
                                            </a>
                                        </div>
                                        */}

                    <div className="menu-item px-5">
                      <NavLink to={"/zmena-hesla"} className="menu-link px-5">
                        {t("auth.changePassword")}
                      </NavLink>
                    </div>

                    <div className="menu-item px-5">
                      <NavLink to={"/nastaveni"} className="menu-link px-5">
                        {t("navigation.settings")}
                      </NavLink>
                    </div>

                    <div className="menu-item px-5">
                      <span onClick={logout} className="menu-link px-5">
                        {t("auth.logout")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="wrapper d-flex flex-column flex-row-fluid container-xxl"
          id="kt_wrapper"
        >
          <div
            className="toolbar d-flex flex-stack flex-wrap py-4 gap-2"
            id="kt_toolbar"
          >
            <div className="page-title d-flex flex-column">
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 mb-1">
                <li className="breadcrumb-item text-gray-700 fw-bold lh-1">
                  <NavLink to="/" className="text-gray-600 text-hover-primary">
                    <i className="ki-duotone ki-home text-gray-700 fs-6"></i>
                  </NavLink>
                </li>

                <li className="breadcrumb-item">
                  <i className="ki-duotone ki-right fs-7 text-gray-700 mx-n1"></i>
                </li>

                {breadcrumbs?.map((breadcrumb, breadcrumb_key) => (
                  <>
                    <li className="breadcrumb-item text-gray-700 fw-bold lh-1">
                      <NavLink
                        to={breadcrumb.link}
                        className="text-gray-600 text-hover-primary"
                      >
                        {breadcrumb.name}
                      </NavLink>
                    </li>

                    <li className="breadcrumb-item">
                      <i className="ki-duotone ki-right fs-7 text-gray-700 mx-n1"></i>
                    </li>
                  </>
                ))}

                <li className="breadcrumb-item text-gray-500 mx-n1">
                  {pagename}
                </li>
              </ul>

              <h1 className="page-heading d-flex flex-column justify-content-center text-gray-900 fw-bolder fs-3 m-0">
                {pagename}
              </h1>
            </div>
          </div>

          <div className="d-flex flex-row flex-column-fluid align-items-stretch">
            <div className="content flex-row-fluid" id="kt_content">
              {children}
            </div>
          </div>

          <div
            className="footer py-4 d-flex flex-column flex-md-row align-items-center justify-content-between"
            id="kt_footer"
          >
            <div className="order-2 order-md-1">
              <span className="text-white opacity-75 fw-semibold me-1">
                2025&copy;
              </span>
              <a
                href="https://keenthemes.com"
                target="_blank"
                className="text-white text-hover-primary opacity-75"
              >
                Exclusive Networks Czechia s.r.o.
              </a>
            </div>

            <ul className="menu menu-white menu-hover-primary fw-semibold order-1 opacity-75">
              <li className="menu-item">
                <a
                  href="https://www.exclusive-networks.com/cz/wp-content/uploads/sites/40/2022/05/Za%CC%81sady-ochrany-soukromi%CC%81.pdf"
                  target="_blank"
                  className="menu-link px-2"
                >
                  {t("legal.privacyPolicy")}
                </a>
              </li>
              <li className="menu-item">
                <a
                  href="https://www.exclusive-networks.com/cz/wp-content/uploads/sites/40/2025/06/2025_Obchodni_podminky.pdf"
                  target="_blank"
                  className="menu-link px-2"
                >
                  {t("legal.termsProjects")}
                </a>
              </li>
              <li className="menu-item">
                <a
                  href="https://www.exclusive-networks.com/cz/wp-content/uploads/sites/40/2025/06/2025_Podminky-akce.pdf"
                  target="_blank"
                  className="menu-link px-2"
                >
                  {t("legal.termsEvents")}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {windowSize && windowSize.width < 992 && showMenu && (
        <div className="drawer-overlay" onClick={() => setShowMenu(false)} />
      )}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </>
  );
}
